<template>

  <form @submit="Submit" v-if="this.personWeaponForm">

  <!-- {{this.editedCampLocation}} -->
  <div class="row">

      <div class="col">
          <div class="mb-12">

          <TextInputVue tabindex="0" input-id="weaponSerialInput" label-text="Serial Number:" :input-v-model="this.personWeaponForm.serialNumber" object-key="serialNumber" @update-form="UpdateForm" :disabled="disabled"></TextInputVue>

          </div>
      </div>

  </div>

  <div class="row">

    <div class="col">
        <div class="mb-12">

        <TextInputVue tabindex="0" input-id="weaponSourceInput" label-text="Weapon Source:" :input-v-model="this.personWeaponForm.weaponSource" object-key="weaponSource" @update-form="UpdateForm" :disabled="disabled"></TextInputVue>

        </div>
    </div>

  </div>

  <div class="row">

      <div class="col">
          <div class="mb-12">

            <DropdownInputVue tabindex="0" input-id="weaponNameId" label-text="Weapon Name:" :input-v-model="this.personWeaponForm.weaponNameId" object-key="weaponNameId" :option-list="this.weaponNameDropdownValues" @update-form="UpdateForm" @blur="v$.personWeaponForm.weaponNameId.$touch" :my-errors="v$.personWeaponForm.weaponNameId.$errors"  :disabled="disabled" ></DropdownInputVue>

          </div>
      </div>

  </div>

  <div class="row">

    <div class="col">
        <div class="mb-12">

          <label tabindex="0" for="qualExpireDate" class="form-label">Qual Expire Date</label>
          <input tabindex="0" type="date" class="form-control" id="qualExpireDate" v-model="this.personWeaponForm.qualExpire"  >
          <div class="errorMessageForm" v-for="error of v$.personWeaponForm.qualExpire.$errors" :key="error.$uid">
              {{error.$message}}
          </div>
        </div>
    </div>

  </div>

  </form>

</template> 
  
<script> 

  import TextInputVue from "@/components/formComponents/TextInput.vue";
  import DropdownInputVue from "@/components/formComponents/DropdownInput.vue";
  import { store } from "@/store/store.js";
  import $ from "jquery";
  import { useVuelidate } from '@vuelidate/core';
  import { required, helpers, minValue} from '@vuelidate/validators'; 
  import { ajaxGetAndReturn } from "@/components/helpers/utilities";

  export default {
    name: "EmptyComponent",
    components: {
      TextInputVue,
      DropdownInputVue
    }, 
    setup () {
      return { v$: useVuelidate() }
    },
    data(){
      return{
        isMounted : false,
        notSubmitted:true,
        personWeaponForm:null,
        weaponNameDropdownValues:null,
        disabled:0,
      }
    },
    props: {
      personWeaponObject:Object,
      mode:String,
    },
    watch:{
        personWeaponObject(){

          console.log("prop person changed. settting editable object.");
          if(this.v$ != null)
            this.v$.$reset();
          if(this.personWeaponObject != null)
            this.personWeaponForm = this.personWeaponObject;
        }
    },

    created(){ // called BEFORE rendering (load data here)
      if(this.personWeaponObject != null)
        this.personWeaponForm = this.personWeaponObject;

      //get weapon names from db: 
      ajaxGetAndReturn(store.webAPIUrl + "weaponNames/getDropdown", (result) =>{
          this.weaponNameDropdownValues = result; 
      });
      
      if(this.mode == "edit"){
        this.disabled = 1; 
      }
    },
    mounted() { // called afer rendering
      this.isMounted = true; 
      console.log("mounted bleh");
    },

    methods:{
      async Submit(){
        const isFormCorrect = await this.v$.$validate();
        // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
        if (!isFormCorrect) return;

        var method = "";
        var actionUrl = "";

        this.personWeaponForm.createDate = new Date();
        this.personWeaponForm.updateDate = new Date();

        if(this.personWeaponForm.personWeaponId != null && this.personWeaponForm.personWeaponId != 0){
            method = "PUT";
            actionUrl = store.webAPIUrl + "PersonWeapons/" + this.personWeaponForm.personWeaponId;
        }
        else{
          method = "POST";
          actionUrl = store.webAPIUrl + "PersonWeapons"; 
        }

        $.ajax({
            method: method,
            data: JSON.stringify(this.personWeaponForm),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            url: actionUrl,
            success: (result) => {

                var successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
                console.log(successMessage);
                this.$emit("PersonWeaponSubmitted");
            },
        });

      },
      UpdateForm(objKey, modelData){
        console.log("dropdowkksajdlfk")
        this.personWeaponForm[objKey] = modelData;
      },
    },
    unmounted(){ //called when the page is left or the component is destroyed

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    },
    validations () {
      return {
        personWeaponForm:{
/*               serialNumber: {
                  required:helpers.withMessage("Serial Number is Required", required)
              },
              weaponSource: {
                  required:helpers.withMessage("Weapon Source is Required", required)
              }, */
              weaponNameId: {
                    minValue: helpers.withMessage("Weapon Name is Required", minValue(1))
              },
              qualExpire:{
                required:helpers.withMessage("Qual Expire is Required", required)
              }
            },
          }
      }
  }
</script>
  
<style scoped>
</style>
